export interface WorkspaceClosureApiResource {
  is_scheduled: boolean;
  closure_requested_at: string | null;
  closure_due_at: string | null;
}

export interface WorkspaceClosure {
  isScheduled: boolean;
  closureRequestedAt: string | null;
  closureDueAt: string | null;
}

export function mapApiResourceToWorkspaceClosure(
  resource: WorkspaceClosureApiResource
): WorkspaceClosure {
  return {
    isScheduled: resource.is_scheduled,
    closureRequestedAt: resource.closure_requested_at,
    closureDueAt: resource.closure_due_at,
  };
}
